export const getDefaultState = () => {
  return {
    userData: null,
    ownLogo: null,
    userAvatar: null,
    userAvatarKey: null,
    credentials: {
    },
    // this state will check if user sign up
    isSignUp: false,
  };
};
export const state = getDefaultState();
